export default "__VITE_ASSET__98c49f98__"